import { ArrowContainer, Popover } from "react-tiny-popover";
import { Box } from "rebass";
import { theme } from "../../utils";

const BasicPopover = ({
  content,
  positions = ["bottom", "right", "top", "left"],
  containerStyle = null,
  children,
  ...props
}) => (
  <Popover
    // align={'start'}
    // padding={0}
    {...{ positions }}
    content={({ position, childRect, popoverRect }) => (
      <ArrowContainer
        position={position}
        childRect={childRect}
        popoverRect={popoverRect}
        arrowColor={"#414141"}
        arrowSize={5}
      >
        <Box
          sx={
            containerStyle || {
              fontWeight: "bold",
              fontSize: "0.7em",
              maxWidth: ["75vw", "60vw"],
              background: "#414141",
              color: "#fff",
              padding: "10px",
              wordWrap: "break-word",
            }
          }
        >
          {content}
        </Box>
      </ArrowContainer>
    )}
    {...props}
  >
    {children}
  </Popover>
);

export default BasicPopover;
